import joi from 'joi';
import { Record as record } from 'immutable';

import trainTime from '../../lib/TrainTime';
import { translate as t } from '../../lib/I18n';
import ValidationMixin from '../ValidationMixin';

const minAge = trainTime.duration('P5Y');

const defaults = {
    year: null,
    month: null,
    day: null,
    isDirty: false
};

class DateOfBirth extends record(defaults) {

    getComputedValues() {
        const dateOfBirth = this.getDateOfBirth();
        const isInvalidDate = !!(dateOfBirth && !dateOfBirth.isValid());
        const isTooYoung = !!(dateOfBirth && !isInvalidDate && this.isTooYoung(dateOfBirth));
        const isInFuture = !!(dateOfBirth && dateOfBirth.isValid() && dateOfBirth.isAfter(trainTime()));
        return {
            isInFuture,
            isInvalidDate,
            isTooYoung
        };
    }

    getSchema () {
        return {
            day: joi.number().integer().min(1).max(31).messages({
                'number.base': t('alertmessage.choose'),
            }),
            month: joi.number().integer().min(1).max(12).messages({
                'number.base': t('alertmessage.choose'),
            }),
            year: joi.number().integer().messages({
                'number.base': t('alertmessage.choose'),
            }),
            isInFuture: joi.any().valid(null, false).messages({
                'any.only': t('alertmessage.date.future'),
            }),
            isInvalidDate: joi.any().valid(false).messages({
                'any.only': t('alertmessage.date.invalid'),
            }),
            isTooYoung: joi.any().valid(false).messages({
                'any.only': t('alertmessage.date.tooYoung'),
            })
        };
    }

    getDateOfBirth () {
        const { day, month, year } = this;
        return day && month && year && trainTime(`${year}-${month}-${day}`, 'YYYY-MM-DD');
    }

    isTooYoung (dateOfBirth) {
        const youngest = trainTime().subtract(minAge);
        return dateOfBirth && dateOfBirth.isValid() && dateOfBirth.isAfter(youngest);
    }

    isOverAge (years) {
        const DoB = this.getDateOfBirth();
        if (DoB) {
            return DoB.isBefore(trainTime().subtract(years, 'years'));
        }
        return undefined;
    }

}

Object.assign(DateOfBirth.prototype, ValidationMixin);

export default DateOfBirth;
